// ─────────────────────────────────────────────
// Oike — Gastos (Finanzas): the four tables Omni created on 04-11-2026 in the original central base
// (appilTHSsdc8Ioyvg). Business expenses go to centralBaseId(); personal ones to ownerBaseId() (today the same base:
// OIKE_OWNER_BASE_ID is not defined in production). Both scopes are only the owner's (expenses.mts checks it on every
// call); the generic proxy refuses the four tables. Field names as created; field ids for reference.
// Payments of expenses are NOT `Payments` (that table is money coming in, with receipts): never mixed.
// ─────────────────────────────────────────────

export const EXPENSE_SCOPES = ['business', 'personal'];
export const EXPENSE_CURRENCIES = ['EUR', 'USD', 'BOB'];
export const RECURRENCES = ['none', 'monthly', 'yearly'];
export const EXPENSE_STATUSES = ['open', 'cancelled'];
export const PAID_FROM = ['business', 'personal', 'other'];
export const PAYMENT_METHODS = ['transfer', 'card', 'cash', 'direct_debit', 'other'];
export const EXPENSE_PAYMENT_STATUSES = ['pending', 'confirmed', 'voided'];

export const EXPENSE_TABLES = {
  business: { expenses: 'Business Expenses', payments: 'Business Expense Payments' },
  personal: { expenses: 'Personal Expenses', payments: 'Personal Expense Payments' },
};

/** Table ids (confirmed by Omni, 04-11-2026), used by the generic proxy to refuse them; the code writes by name. */
export const EXPENSE_TABLE_IDS = {
  business: { expenses: 'tbloSPcxbVwVFrTqB', payments: 'tbl7tKMhn68jImPiH' },
  personal: { expenses: 'tblzwbBKcb7CLDjFM', payments: 'tblPxbT2Hn0trI4RH' },
};

export const EXPENSE = {
  name: 'Name', concept: 'Concept', supplier: 'Supplier', amount: 'Amount', currency: 'Currency',
  incurredOn: 'Incurred On', dueOn: 'Due On', category: 'Category', receipts: 'Receipt Files', recurrence: 'Recurrence',
  seriesKey: 'Series Key', period: 'Period', status: 'Expense Status', key: 'Expense Key', intent: 'Payment Intent',
  note: 'Note', log: 'Expense Log', createdBy: 'Created By', createdAt: 'Created At', updatedAt: 'Updated At', payments: 'Payments',
};
export const EXPENSE_PAYMENT = {
  name: 'Name', expense: 'Expense', amount: 'Amount', currency: 'Currency', paidOn: 'Paid On', paidFrom: 'Paid From',
  method: 'Method', reference: 'Reference', status: 'Payment Status', key: 'Payment Key', voidReason: 'Void Reason',
  log: 'Payment Log', recordedBy: 'Recorded By', confirmedAt: 'Confirmed At', voidedAt: 'Voided At',
};

/** Field ids as Omni reported them (for reference and support; the code writes by name). */
export const EXPENSE_FIELD_IDS = {
  'Business Expenses': {
    Name: 'fldsChVwHYyhcNYn4', Concept: 'fld2HgpCGfizDHSiU', Supplier: 'fldUjjKn3hJ6TZepr', Amount: 'fldSz1pGWWVaUNw02', Currency: 'fldTrfNsIK4ClqxHt',
    'Incurred On': 'fldmfjvePwNGVE3Km', 'Due On': 'fldHYeBsCNznLR1dL', Category: 'fldDaue9Tm2QEzQAD', 'Receipt Files': 'fldarpBhktwWCDTF0',
    Recurrence: 'fldH7Hd8xDH1UruPm', 'Series Key': 'fldfVcpD1dpwNofHP', Period: 'fldncTItMrplBAYfG', 'Expense Status': 'fldoQEX3OW3BHo27D',
    'Expense Key': 'flderrlEOX915vnTj', 'Payment Intent': 'fldBI9HtOAY7Wzg1K', Note: 'fldDNfDmRT7dKS1Z9', 'Expense Log': 'fldouxIOaFMOuCa9m',
    'Created By': 'fldkVbeTuo9jJ7408', 'Created At': 'fld3vTKxnYnsf8ph7', 'Updated At': 'fldWX59aAOOZr7yPp', Payments: 'fldlPItjSXeMcPphn',
  },
  'Business Expense Payments': {
    Name: 'fldsSWaoEjzAIVPQF', Expense: 'fldtgKpGk3xy7KlNN', Amount: 'fldeQFABFQykciIBP', Currency: 'fldWAKvkvObT7SLvL', 'Paid On': 'fldOiUJstQX2EHZZW',
    'Paid From': 'fld0wpy5zkyzCTGU9', Method: 'fldiGUBKaQHK6VLsr', Reference: 'fldfWgDOgkV2EbVfH', 'Payment Status': 'fldnaITFuSSE96jl4',
    'Payment Key': 'fldl34yich6zY3diY', 'Void Reason': 'fldWXoz7k9InpFaMt', 'Payment Log': 'fldwcBojBB2guPgTo', 'Recorded By': 'fldv4LS8oUmrnt2dS',
    'Confirmed At': 'fldDN1NJxnkqUpbKS', 'Voided At': 'fldJN7tNl1tOffeXX',
  },
  'Personal Expenses': {
    Name: 'fldVFym6xB1M1vVJ6', Concept: 'fldDbhG4lsvsh6qkv', Supplier: 'fldd1ICH9GP5kSB2p', Amount: 'fldZbZvF7udb0JUfL', Currency: 'fld0ntYFyAJpKI0vy',
    'Incurred On': 'fldyJkIky3rXsO8HG', 'Due On': 'fldWRS61lPPogBF3q', Category: 'fldQdSloHHkDL2VqH', 'Receipt Files': 'fldxn38VfvwGeWmEd',
    Recurrence: 'fldiDda9SU4TScsyf', 'Series Key': 'fld6yQACaswNadbTZ', Period: 'fldBhfLpuFAm7OYXw', 'Expense Status': 'fldWGqEvaWiNSX814',
    'Expense Key': 'fldvtRBwExLEiS9md', 'Payment Intent': 'fldnGk61XqMfYHnAg', Note: 'fld8M2f0jw4hgUWbf', 'Expense Log': 'fldx9gRMawM05mr82',
    'Created By': 'fld6ArjQnAQjHxV8x', 'Created At': 'fldqMBDJbbb9auFIV', 'Updated At': 'fld8Dw8taVuqTTjH7', Payments: 'fldnbACPTwPKbcvuX',
  },
  'Personal Expense Payments': {
    Name: 'fldBC93GSqkWarQgZ', Expense: 'fldZ41Ba1velUux46', Amount: 'fldOFrniyLbYk5MZ8', Currency: 'fldb7iQvzBHZwP6Ar', 'Paid On': 'fldh05lIM6Vb7Ft9K',
    'Paid From': 'fldXzXDsJEqSaKgtt', Method: 'fldVRh6M74OZnzf5Y', Reference: 'fld3ZOI0vqT4h0Cv7', 'Payment Status': 'fldKST0VzNKq6nYQw',
    'Payment Key': 'fldyCNTQYwSPEuU1a', 'Void Reason': 'fldAsZ5XkVZHROHGs', 'Payment Log': 'fldd7snqMLb9rb4Nh', 'Recorded By': 'fldHv43ZLLiM93TJo',
    'Confirmed At': 'fldlmqT3rUVCZL0bF', 'Voided At': 'fldNHBRF6GWafzbbU',
  },
};

// Categories (approved 04-11-2026): short, editable lists kept in Personal Connections › owner_settings › Settings
// (`expenseCategories`), merged with the other keys. A key never changes; renaming keeps the history consistent and an
// archived category stays on the expenses that use it.
export const DEFAULT_EXPENSE_CATEGORIES = {
  business: [
    ['software', 'Herramientas y software'], ['learning', 'Formación y libros'], ['professional', 'Servicios profesionales (contaduría, legal, diseño)'],
    ['marketing', 'Marketing y publicidad'], ['travel', 'Viajes y traslados'], ['equipment', 'Equipamiento'], ['office', 'Oficina y conexión'],
    ['banking', 'Comisiones bancarias y de cobro'], ['taxes', 'Tasas e impuestos (solo registro)'], ['other', 'Otros'],
  ].map(([key, label]) => ({ key, label, archived: false })),
  personal: [
    ['home', 'Vivienda'], ['food', 'Alimentación'], ['health', 'Salud'], ['transport', 'Transporte'], ['education', 'Educación'],
    ['leisure', 'Ocio'], ['care', 'Ropa y cuidado personal'], ['family', 'Familia'], ['insurance', 'Seguros'], ['other', 'Otros'],
  ].map(([key, label]) => ({ key, label, archived: false })),
};

export const RECEIPT_MAX_BYTES = 4 * 1024 * 1024;
export const RECEIPT_TYPES = [
  { ext: 'pdf', type: 'application/pdf' }, { ext: 'png', type: 'image/png' }, { ext: 'jpg', type: 'image/jpeg' },
  { ext: 'jpeg', type: 'image/jpeg' }, { ext: 'webp', type: 'image/webp' },
];
export const receiptTypeOf = (name) => {
  const ext = String(name || '').toLowerCase().match(/\.([a-z0-9]+)$/)?.[1] || '';
  return RECEIPT_TYPES.find(t => t.ext === ext) || null;
};

export const LABELS = {
  scope: { business: 'Negocio', personal: 'Personal' },
  paidFrom: { business: 'dinero del negocio', personal: 'dinero personal', other: 'otro origen' },
  method: { transfer: 'Transferencia', card: 'Tarjeta', cash: 'Efectivo', direct_debit: 'Débito automático', other: 'Otro' },
  recurrence: { none: 'No se repite', monthly: 'Cada mes', yearly: 'Cada año' },
};
